import React from 'react';

const logoutHandler = (event) => {
    event.preventDefault()
    document.cookie = `prc-user=;domain=${window.location.hostname};path=/;max-age=0`;
    window.location.href = "/prc/authenticateLogoff.html";
};

export default ({ className }) => {
    return (
        <a
            onClick={logoutHandler}
            className={className}
            href="#/logout"
        >
            Log out
        </a>
    )

}
